// Detects PDF/export mode synchronously at module load.
// Backend appends `?export=1` to the URL when rendering for PDF.
// Components import IS_EXPORT to bypass scroll-triggered animations
// and render statically (so every slide is fully visible in the PDF).
export const IS_EXPORT =
  typeof window !== "undefined" &&
  new URLSearchParams(window.location.search).get("export") === "1";

if (IS_EXPORT && typeof document !== "undefined") {
  // Ensure CSS overrides activate immediately (don't wait for body.exporting via JS)
  document.documentElement.classList.add("export-mode");
}
